// extracted by mini-css-extract-plugin
export default {"tooltip":"FavoriteIcon_tooltip__+d8w3","box":"FavoriteIcon_box__Nhhfh","menuIcon":"FavoriteIcon_menuIcon__ZKHE1"};